import { createContext, useContext } from 'react';
import environment from '../env';
import useSWRImmutable from 'swr/immutable';
import { useAuth } from './AuthProvider';

const DocumentsContext = createContext();

export const useDocuments = () => useContext(DocumentsContext);

const DocumentsProvider = ({ children }) => {
    const { accessToken } = useAuth();

    function useGetDocuments() {
        const defaultOptions = {
            method: "GET",
            headers: {
                "x-api-key": environment.CUSTOMER_PORTAL_API_KEY,
                "Authorization": `Bearer ${accessToken}`,
                "organisation": environment.CLIENT_NAME,
            },
        };
        const url = accessToken ? `${environment.CUSTOMER_PORTAL_API}/documents` : null;
        console.info("Get documents request", { defaultOptions, url })
        const { data, error, isLoading } = useSWRImmutable([url, defaultOptions])
        console.info("Get documents response", { data, error, isLoading })
        return {
            documents: data,
            error,
            isDocumentsLoading: isLoading
        }
    }

    const contextValue = {
        useGetDocuments,
    };

    return (
        <DocumentsContext.Provider value={contextValue}>
            {children}
        </DocumentsContext.Provider>
    );
};

export default DocumentsProvider;